import type { CommunityCoverImage } from "@upsquad/shared";
import { useTranslation } from "react-i18next";
import { CommunityCoverCarousel } from "../../community-cover-carousel";
import { EyebrowBadge } from "../atoms/eyebrow-badge";
import { SectionHeading } from "../atoms/section-heading";

interface LandingGallerySectionProps {
	communityName: string;
	coverImages: CommunityCoverImage[];
}

export function LandingGallerySection({ communityName, coverImages }: LandingGallerySectionProps) {
	const { t } = useTranslation("community");

	if (coverImages.length === 0) return null;

	return (
		<section className="bg-background py-24 md:py-28">
			<div className="mx-auto flex w-full max-w-5xl flex-col items-center gap-12 px-6">
				<SectionHeading
					eyebrow={<EyebrowBadge tone="ink">{t("landing.gallery.eyebrow")}</EyebrowBadge>}
					title={t("landing.gallery.title", { communityName })}
				/>
				<div className="landing-shadow-lift w-full overflow-hidden rounded-3xl">
					<CommunityCoverCarousel images={coverImages} />
				</div>
			</div>
		</section>
	);
}
